import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 5L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L22 5",
		stroke: "#8895A7",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("rect", {
		x: 2,
		y: 5,
		width: 20,
		height: 14,
		rx: 2,
		stroke: "#8895A7",
		strokeWidth: 2
	})]
});
export default SvgFeed;
